import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {requestSaveJobPipeline} from "@app/services/JobPipelineService";
import {alertMessage} from "@app/constants/Messages";
import JobPipelineInputForm, {JobPipelineInputMode} from "@pages/jobpipeline/edit/JobPipelineInputForm";
import {pipelineOptionsToString, pipelineStringToOptions} from "@pages/jobpipeline/common/PipelineUtil";

const UpdateJobPipelineModal = (props) => {
    const [jobPipeline, setJobPipeline] = useState({});
    const [isAddMode, setAddMode] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {pipeLineInfo, isShow, onClose} = props

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const setJobPipelineInfoForDisplay = (inputJobPipeline) => {
        setJobPipeline(pipelineStringToOptions(inputJobPipeline))
    }

    useEffect(() => {
        if (pipeLineInfo) {
            setJobPipelineInfoForDisplay(pipeLineInfo)
            setAddMode(!pipeLineInfo.id)
        } else {
            setJobPipeline({})
            setAddMode(true)
        }
    }, [pipeLineInfo]);

    const onUpdatePipeLineInfo = () => {
        const body = pipelineOptionsToString(jobPipeline)
        requestSaveJobPipeline(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(res.sts_code === ResponseCode.SUCCESS)
            } else {
                alertMessage(res.sts_code)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onChangeInputItem = (values, column) => {
        jobPipeline[column.key] = values
        // setJobPipeline({...jobPipeline})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {isAddMode ? 'Tạo dòng Pipeline mới' : 'Thông tin job pipeline'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <JobPipelineInputForm mode={jobPipeline.id ? JobPipelineInputMode.Edit : JobPipelineInputMode.Add}
                                          onChangeInputItem={onChangeInputItem} pipeLineInfo={jobPipeline}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={isLoading}
                            onClick={() => {
                                onUpdatePipeLineInfo()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UpdateJobPipelineModal;
